import { render, staticRenderFns } from "./AlignmentPanel.vue?vue&type=template&id=063eb817&"
import script from "./AlignmentPanel.vue?vue&type=script&lang=js&"
export * from "./AlignmentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports